import React, { useState } from 'react';
import {
  IconTestPipe,
  IconChartLine,
  IconHeartbeat,
  IconPill,
  IconSparkles,
  IconVaccine,
  IconPrescription,
  IconStethoscope,
  IconFileDescription,
} from '@tabler/icons-react';

// ---------------------------------------------------------------------------
// Sub-nav configuration — single source of truth for chart sections
// ---------------------------------------------------------------------------
export const CHART_SECTIONS = [
  { key: 'labs',          label: 'Labs',             icon: IconTestPipe,        stage: 'Stage 4–5' },
  { key: 'gfr',           label: 'GFR Graph',        icon: IconChartLine,       stage: 'Stage 6' },
  { key: 'vitals',        label: 'Vitals',           icon: IconHeartbeat,       stage: 'Stage 7' },
  { key: 'meds',          label: 'Medications',      icon: IconPill,            stage: 'Stage 9' },
  { key: 'care_opt',      label: 'Care Optimization',icon: IconSparkles,        stage: 'Stage 8' },
  { key: 'anemia',        label: 'ESA / Iron Therapy',icon: IconVaccine,        stage: 'Stage 10' },
  { key: 'hd_orders',     label: 'HD Orders',        icon: IconPrescription,    stage: 'Stage 11' },
  { key: 'care_planning', label: 'Care Planning',    icon: IconStethoscope,     stage: 'Stage 12' },
  { key: 'handouts',      label: 'Handouts',         icon: IconFileDescription, stage: 'Stage 13' },
];

// ---------------------------------------------------------------------------
// ChartSubNav
// ---------------------------------------------------------------------------
export default function ChartSubNav({ activeSection, onSelect }) {
  const [hoveredKey, setHoveredKey] = useState(null);

  return (
    <div style={styles.subNav}>
      {CHART_SECTIONS.map((section, index) => {
        const Icon = section.icon;
        const isActive = activeSection === section.key;
        const isHovered = hoveredKey === section.key;
        return (
          <React.Fragment key={section.key}>
            {index > 0 && <div style={styles.subNavDivider} />}
            <button
              style={{
                ...styles.subNavItem,
                ...(isActive ? styles.subNavItemActive : {}),
                ...(!isActive && isHovered ? styles.subNavItemHover : {}),
              }}
              onClick={() => onSelect(section.key)}
              onMouseEnter={() => setHoveredKey(section.key)}
              onMouseLeave={() => setHoveredKey(null)}
            >
              <Icon
                size={20}
                stroke={1.5}
                style={{
                  color: isActive ? 'var(--color-primary)' : 'var(--color-text-secondary)',
                  flexShrink: 0,
                }}
              />
              <span style={{
                ...styles.subNavLabel,
                color: isActive ? 'var(--color-primary)' : 'var(--color-text-primary)',
                fontWeight: isActive ? 'var(--font-weight-semibold)' : 'var(--font-weight-regular)',
              }}>
                {section.label}
              </span>
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
}

// ---------------------------------------------------------------------------
// Styles
// ---------------------------------------------------------------------------
const styles = {
  subNav: {
    width: '180px',
    flexShrink: 0,
    backgroundColor: 'var(--color-subNav)',
    border: '1px solid var(--color-border)',
    borderRadius: 'var(--radius-sm)',
    padding: '4px 0',
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    alignSelf: 'flex-start',
  },
  subNavItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '9px 14px',
    appearance: 'none',
    WebkitAppearance: 'none',
    background: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    borderLeft: '3px solid transparent',
    cursor: 'pointer',
    width: '100%',
    textAlign: 'left',
    transition: 'background-color var(--transition-fast)',
    borderRadius: '0',
  },
  subNavItemActive: {
    backgroundColor: 'var(--color-bg-card)',
    borderLeft: '3px solid var(--color-primary)',
    minHeight: '52px',
    alignItems: 'center',
  },
  subNavItemHover: {
    backgroundColor: 'var(--color-accent-wash)',
  },
  subNavLabel: {
    fontSize: '13px',
    fontFamily: 'var(--font-family-base)',
    lineHeight: 1.3,
  },
  subNavDivider: {
    height: '1px',
    backgroundColor: 'var(--color-border)',
    margin: '0 14px',
  },
};